import { useEffect, useState } from 'react';
import { getListPaymentMethodsQuery } from '../../../../api';
import useApi from '../../../../hook/useApi';

import { useSelector } from 'react-redux';
import { storeAllPaymentsAction } from '../../../../store/slices/payments';
import {
  cleanAddressString,
  FORMATE_AMOUNT,
  FORMATE_DATE,
  PARSIFY,
} from '../../../../helpers/helpers';
import {
  cancelShipmentMutation,
  getAllPendingShipmentsFromLocationQuery,
} from '../../../../api/services/shipments.service';
import {
  cancelShipmentAction,
  storePendingShipmentsAction,
} from '../../../../store/slices/shipmentsSlice';
import toast from 'react-hot-toast';
import { TOAST_TIME } from '../../../../constants/toastNotifications';

export const usePendingShipmentsLis = () => {
  const [shipmentActionClickedData, setShipmentActionClickedData] =
    useState(null);
  const [shipmentActionClickedId, setShipmentActionClickedId] = useState(null);
  const [toggleActionMenuId, setToggleActionMenuId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { shipments } = useSelector((state) => state);

  const [getAllShipmentsFromLocation] = useApi(
    getAllPendingShipmentsFromLocationQuery,
    storePendingShipmentsAction
  );
  const [getListPaymentMethods] = useApi(
    getListPaymentMethodsQuery,
    storeAllPaymentsAction
  );
  const [cancelShipmentCall, cancelShipmentLoading] = useApi(
    cancelShipmentMutation,
    cancelShipmentAction
  );
  const openDeleteModal = () => setShowDeleteModal(true);
  const closeDeleteModal = () => setShowDeleteModal(false);
  const user = JSON.parse(localStorage.getItem('login-user'));
  const locationId = parseInt(user.locationId);
  console.log('user type:', typeof locationId);

  useEffect(() => {
    user && getAllShipmentsFromLocation(locationId);
    fetchPaymentMethodsList();
  }, []);
  const cancelShipmentHandler = async (shipmentId) => {
    toast.dismiss();
    toast.loading('Deleting shipment...');
    const { data, errors } = await cancelShipmentCall(shipmentId);
    if (data) {
      const user = JSON.parse(localStorage.getItem('login-user'));
      getAllShipmentsFromLocation(user.locationId);
      toast.dismiss();
      toast.success('Shipment deleted successfully', { duration: TOAST_TIME });
    }
    if (errors) {
      toast.dismiss();
      toast.error('error in canceling shipment', { duration: TOAST_TIME });
    }

    return { data, errors };
  };

  const fetchPaymentMethodsList = async () => {
    const { data, errors } = await getListPaymentMethods(
      user.location && user.location.stripeCustomerID
    );
  };

  const handleActionClick = (e, data) => {
    e.stopPropagation();
    setShipmentActionClickedId(parseInt(data?.id));
    setShipmentActionClickedData(data);
    setToggleActionMenuId((prev) => (prev === data.id ? null : data.id));
  };
  console.log(shipments, 'shipments')
  const modifiedShipmentsData = shipments?.pendingShipments && shipments?.pendingShipments?.length > 0 && shipments?.pendingShipments.map((shipment) => {
    // console.log('shipment.location.entity:', shipment.location.entity);
    // console.log('country:', PARSIFY(shipment?.to)?.country);
    const parsedFromAddress = PARSIFY(shipment.from.address);
    let addressString =
      parsedFromAddress?.street +
      ' ' +
      parsedFromAddress?.city +
      ' ' +
      parsedFromAddress?.state +
      ' ' +
      parsedFromAddress?.country +
      ', ' +
      parsedFromAddress?.zipCode;

    const cleanAddress = cleanAddressString(addressString);
    const fromAddress = [shipment?.from?.nickName, cleanAddress];
    return {
      ...shipment,
      id: shipment.id,
      from: fromAddress,
      recipient: (PARSIFY(shipment.to) && PARSIFY(shipment.to).name) || '---',
      carrier: shipment.carrier && shipment.carrier.name,
      pickup: FORMATE_DATE(shipment?.pickUpDate),
      delivery: FORMATE_DATE(shipment?.deliveryDate),
      value: FORMATE_AMOUNT(shipment.totalValue),
      premium: shipment?.premium
        ? FORMATE_AMOUNT(shipment.premium)
        : 'UNPAID',
      confirmation: shipment.confirmationId ? shipment.confirmationId : 'N/A',
      trialed: shipment.subscribers == 'true' ? true : false,
      reference:
        (PARSIFY(shipment.to) && PARSIFY(shipment.to).reference) || '---',
    };
  });

  return {
    data: modifiedShipmentsData,
    handleActionClick,
    shipmentActionClickedData,
    setShipmentActionClickedData,
    shipmentActionClickedId,
    setShipmentActionClickedId,
    toggleActionMenu: toggleActionMenuId,
    setToggleActionMenuId,
    cancelShipmentLoading,
    cancelShipmentHandler,
    closeDeleteModal,
    openDeleteModal,
    showDeleteModal,
  };
};
